import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/** Active student (customer) portal theme from GET /api/student-theme. */
export interface StudentTheme {
  id: number;
  themeName: string;
  portal?: string;
  primaryColor: string;
  secondaryColor: string;
  backgroundColor: string;
  surfaceColor: string;
  textPrimaryColor: string;
  textSecondaryColor: string;
  successColor: string;
  warningColor: string;
  errorColor: string;
  infoColor: string;
  sidebarBackground: string;
  sidebarTextColor: string;
  headerBackground: string;
  headerTextColor: string;
  logoUrl?: string | null;
  siteLogoUrl?: string | null;
  homeLetterLogoUrl?: string | null;
  tokens: Record<string, string>;
}

@Injectable({
  providedIn: 'root',
})
export class StudentThemeService {
  private readonly baseUrl = `${environment.apiBaseUrl}/student-theme`;

  constructor(private http: HttpClient) {}

  getActiveTheme(): Observable<StudentTheme> {
    return this.http.get<StudentTheme>(this.baseUrl);
  }
}
